import { useState } from 'react';
import { useSelector } from 'react-redux';

import Subpage from '@/ui/components/subpage';
import { ALL_OPTION } from '@/ui/constants';
import exodus from '@/ui/exodus';
import enabledAssetsSelector from '@/ui/flux/assets/selectors/enabled-assets';
import useActivity from '@/ui/hooks/use-activity';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import { isAllOption } from '@/ui/utils/content';
import Activity from './components/activity.js';
import EmptyState from './components/empty-state.js';
import Filters from './components/filters.js';
import type { ActivityTypeSelection, AssetSelection } from './types.js';

function History() {
  const [selectedTypes, setSelectedTypes] =
    useState<ActivityTypeSelection>(ALL_OPTION);
  const [selectedAssets, setSelectedAssets] =
    useState<AssetSelection>(ALL_OPTION);

  const assets = useSelector(enabledAssetsSelector);

  const activity = useActivity({
    type: isAllOption(selectedTypes)
      ? 'all'
      : selectedTypes.map((type) => type.key),
    assetNames: isAllOption(selectedAssets)
      ? Object.keys(assets)
      : selectedAssets.map((asset) => asset.name),
  });
  const hasActivity = activity.length > 0;

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'HistoryView',
    });
  }, []);

  const isFiltering =
    !isAllOption(selectedTypes) || !isAllOption(selectedAssets);

  return (
    <Subpage
      title="History"
      className="flex h-full flex-col items-center overflow-hidden"
    >
      <Filters
        selectedActivityTypes={selectedTypes}
        onSelectedActivityTypesChange={setSelectedTypes}
        selectedAssets={selectedAssets}
        onSelectedAssetsChange={setSelectedAssets}
      />
      {hasActivity ? (
        <Activity activity={activity} />
      ) : (
        <EmptyState isFiltering={isFiltering} />
      )}
    </Subpage>
  );
}

export default History;
